var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 55,
    viewBox: "0 0 86 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 44 Copy 8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.08906,
    y: 1.3,
    width: 83.2668,
    height: 52.856,
    rx: 3.388,
    stroke: "#106C3A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 8",
    d: "M6.63649 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 9",
    d: "M8.79078 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 11",
    d: "M10.9451 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 10",
    d: "M13.0994 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 13",
    d: "M15.2537 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 12",
    d: "M17.408 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 15",
    d: "M19.5623 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 14",
    d: "M21.7166 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 17",
    d: "M23.8709 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 16",
    d: "M26.0252 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 19",
    d: "M28.1795 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 18",
    d: "M30.3357 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 31",
    d: "M32.49 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 30",
    d: "M34.6443 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 29",
    d: "M36.7986 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 28",
    d: "M38.9529 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 27",
    d: "M41.1072 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 26",
    d: "M43.2615 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 25",
    d: "M45.4158 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 24",
    d: "M47.5701 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 23",
    d: "M49.7244 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 22",
    d: "M51.8787 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 21",
    d: "M54.033 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 20",
    d: "M56.1873 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 42",
    d: "M58.3416 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 41",
    d: "M60.4959 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 40",
    d: "M62.6502 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 39",
    d: "M64.8045 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 38",
    d: "M66.9588 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 37",
    d: "M69.113 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 36",
    d: "M71.2673 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 35",
    d: "M73.4216 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 34",
    d: "M75.5779 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 33",
    d: "M77.7322 38.4482V40.0562",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 8_2",
    d: "M6.63649 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 9_2",
    d: "M8.79078 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 11_2",
    d: "M10.9451 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 10_2",
    d: "M13.0994 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 13_2",
    d: "M15.2537 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 12_2",
    d: "M17.408 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 15_2",
    d: "M19.5623 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 14_2",
    d: "M21.7166 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 17_2",
    d: "M23.8709 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 16_2",
    d: "M26.0252 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 19_2",
    d: "M28.1795 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 18_2",
    d: "M30.3357 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 31_2",
    d: "M32.49 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 30_2",
    d: "M34.6443 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 29_2",
    d: "M36.7986 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 28_2",
    d: "M38.9529 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 27_2",
    d: "M41.1072 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 26_2",
    d: "M43.2615 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 25_2",
    d: "M45.4158 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 24_2",
    d: "M47.5701 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 23_2",
    d: "M49.7244 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 22_2",
    d: "M51.8787 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 21_2",
    d: "M54.033 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 20_2",
    d: "M56.1873 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 42_2",
    d: "M58.3416 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 41_2",
    d: "M60.4959 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 40_2",
    d: "M62.6502 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 39_2",
    d: "M64.8045 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 38_2",
    d: "M66.9588 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 37_2",
    d: "M69.113 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 36_2",
    d: "M71.2673 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 35_2",
    d: "M73.4216 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 34_2",
    d: "M75.5779 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 33_2",
    d: "M77.7322 42.7358V44.3438",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8 Copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 8_3",
    d: "M6.63649 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 9_3",
    d: "M8.79078 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 11_3",
    d: "M10.9451 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 10_3",
    d: "M13.0994 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 13_3",
    d: "M15.2537 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 12_3",
    d: "M17.408 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 15_3",
    d: "M19.5623 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 14_3",
    d: "M21.7166 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 17_3",
    d: "M23.8709 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 16_3",
    d: "M26.0252 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 19_3",
    d: "M28.1795 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 18_3",
    d: "M30.3357 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 31_3",
    d: "M32.49 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 30_3",
    d: "M34.6443 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 29_3",
    d: "M36.7986 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 28_3",
    d: "M38.9529 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 27_3",
    d: "M41.1072 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 26_3",
    d: "M43.2615 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 25_3",
    d: "M45.4158 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 24_3",
    d: "M47.5701 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 23_3",
    d: "M49.7244 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 22_3",
    d: "M51.8787 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 21_3",
    d: "M54.033 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 20_3",
    d: "M56.1873 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 42_3",
    d: "M58.3416 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 41_3",
    d: "M60.4959 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 40_3",
    d: "M62.6502 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 39_3",
    d: "M64.8045 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 38_3",
    d: "M66.9588 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 37_3",
    d: "M69.113 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 36_3",
    d: "M71.2673 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 35_3",
    d: "M73.4216 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 34_3",
    d: "M75.5779 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7 Copy 33_3",
    d: "M77.7322 47.0239V48.6319",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 22",
    d: "M1.87194 30.9438H83.6554",
    stroke: "#106C3A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M7.17383 6.82415H26.6325",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy",
    d: "M7.17383 10.5761H30.8721",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 12",
    d: "M7.17383 18.08H26.3613",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 17",
    d: "M30.8725 18.08H48.8818",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 15",
    d: "M57.8022 18.08H73.6571",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 13",
    d: "M7.17383 21.832H19.5616",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 19",
    d: "M34.6426 30.9438H57.8023",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 14",
    d: "M7.17383 25.5839H19.5616",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 16",
    d: "M23.332 25.5839H33.2574",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 2",
    d: "M7.17383 14.3281H22.8592",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdBack);
export default __webpack_public_path__ + "static/media/id-back.8c12e2689beb58538458df35740dfe3d.svg";
export { ForwardRef as ReactComponent };